// extracted by mini-css-extract-plugin
export default {"root":"SplitNavigation-root_gzTs7","singleLink":"SplitNavigation-singleLink_wbYJo","buttonClassName":"SplitNavigation-buttonClassName_C1Mzz","link":"SplitNavigation-link_CL2Ts"};